import { groupBaseModel } from './crud';

export * from './types';

export const useGroupsById = groupBaseModel.fetchById();
export const useGroupsByIds = groupBaseModel.fetchByIds();
export const useGroupsMany = groupBaseModel.fetchMany();
export const useGroupsCount = groupBaseModel.count();
export const useGroupsManyInfiniteQuery = groupBaseModel.fetchPaginated();
export const useGroupsUpdateOne = groupBaseModel.edit();
export const useGroupsCreateOne = groupBaseModel.create();
export const useGroupsRemoveOne = groupBaseModel.delete();
export const useGroupsRemoveByIds = groupBaseModel.deleteByIds();

export const useGroupsByIdV2 = groupBaseModel.fetchByIdV2();
export const useGroupsByIdsV2 = groupBaseModel.fetchByIdsV2();
export const useGroupsManyV2 = groupBaseModel.fetchManyV2();
export const useGroupsCountV2 = groupBaseModel.countV2();
export const useGroupsManyInfiniteQueryV2 = groupBaseModel.fetchPaginatedV2();
export const useGroupsUpdateOneV2 = groupBaseModel.editV2();
export const useGroupsCreateOneV2 = groupBaseModel.createV2();
export const useGroupsRemoveOneV2 = groupBaseModel.deleteV2();
export const useGroupsRemoveByIdsV2 = groupBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useGroupById = groupBaseModel.fetchById();
export const useGroupByIds = groupBaseModel.fetchByIds();
export const useGroupMany = groupBaseModel.fetchMany();
export const useGroupCount = groupBaseModel.count();
export const useGroupPagination = groupBaseModel.fetchPaginated();
export const useGroupUpdateOne = groupBaseModel.edit();
export const useGroupCreateOne = groupBaseModel.create();
export const useGroupRemoveOne = groupBaseModel.delete();
export const useGroupRemoveByIds = groupBaseModel.deleteByIds();

export const useGroupByIdV2 = groupBaseModel.fetchByIdV2();
export const useGroupByIdsV2 = groupBaseModel.fetchByIdsV2();
export const useGroupManyV2 = groupBaseModel.fetchManyV2();
export const useGroupCountV2 = groupBaseModel.countV2();
export const useGroupPaginationV2 = groupBaseModel.fetchPaginatedV2();
export const useGroupUpdateOneV2 = groupBaseModel.editV2();
export const useGroupCreateOneV2 = groupBaseModel.createV2();
export const useGroupRemoveOneV2 = groupBaseModel.deleteV2();
export const useGroupRemoveByIdsV2 = groupBaseModel.deleteByIdsV2();
